// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders } from '../types';

export const TranscodeHttpPostAnalyzeAssetsByAssetId =
  'TranscodeHttpPostAnalyzeAssetsByAssetId' as const;
export const TranscodeHttpPostAnalyzeAssetsByAssetIdProfilesDefault =
  'TranscodeHttpPostAnalyzeAssetsByAssetIdProfilesDefault' as const;
export const TranscodeHttpPostAnalyzeAssetsByAssetIdProfilesDefaultByMediaType =
  'TranscodeHttpPostAnalyzeAssetsByAssetIdProfilesDefaultByMediaType' as const;
export const TranscodeHttpPostAnalyzeAssetsByAssetIdProfilesByProfileId =
  'TranscodeHttpPostAnalyzeAssetsByAssetIdProfilesByProfileId' as const;
export const TranscodeHttpPostAnalyzeBulk =
  'TranscodeHttpPostAnalyzeBulk' as const;
export const TranscodeHttpPostEdgeTranscodeJobsByJobIdAcknowledge =
  'TranscodeHttpPostEdgeTranscodeJobsByJobIdAcknowledge' as const;
export const TranscodeHttpGetEdgeTranscodeWorkers =
  'TranscodeHttpGetEdgeTranscodeWorkers' as const;
export const TranscodeHttpPostEdgeTranscodeWorkers =
  'TranscodeHttpPostEdgeTranscodeWorkers' as const;
export const TranscodeHttpDeleteEdgeTranscodeWorkersByWorkerId =
  'TranscodeHttpDeleteEdgeTranscodeWorkersByWorkerId' as const;
export const TranscodeHttpGetEdgeTranscodeWorkersByWorkerId =
  'TranscodeHttpGetEdgeTranscodeWorkersByWorkerId' as const;
export const TranscodeHttpPatchEdgeTranscodeWorkersByWorkerId =
  'TranscodeHttpPatchEdgeTranscodeWorkersByWorkerId' as const;
export const TranscodeHttpPutEdgeTranscodeWorkersByWorkerId =
  'TranscodeHttpPutEdgeTranscodeWorkersByWorkerId' as const;
export const TranscodeHttpPostKeyframesCollectionsByCollectionId =
  'TranscodeHttpPostKeyframesCollectionsByCollectionId' as const;
export const TranscodeHttpPostKeyframesPlaylistsByPlaylistId =
  'TranscodeHttpPostKeyframesPlaylistsByPlaylistId' as const;
export const TranscodeHttpPostMetadataFillingAssetsByAssetIdVersionsByVersionId =
  'TranscodeHttpPostMetadataFillingAssetsByAssetIdVersionsByVersionId' as const;
export const TranscodeHttpPostMetadataFillingBulk =
  'TranscodeHttpPostMetadataFillingBulk' as const;
export const TranscodeHttpGetMetadataFillingProposalsAssetsByAssetIdVersionsByVersionId =
  'TranscodeHttpGetMetadataFillingProposalsAssetsByAssetIdVersionsByVersionId' as const;
export const TranscodeHttpGetMetadataFillingProposalsByJobId =
  'TranscodeHttpGetMetadataFillingProposalsByJobId' as const;
export const TranscodeHttpPostMetadataFillingProposalsByJobIdAccept =
  'TranscodeHttpPostMetadataFillingProposalsByJobIdAccept' as const;
export const TranscodeHttpPostMetadataFillingProposalsByJobIdDiscard =
  'TranscodeHttpPostMetadataFillingProposalsByJobIdDiscard' as const;
export const TranscodeHttpPostMetadataFillingProposalsByJobIdRegenerate =
  'TranscodeHttpPostMetadataFillingProposalsByJobIdRegenerate' as const;
export const TranscodeHttpPostMetadataFillingProposalsByParentJobIdBulkAccept =
  'TranscodeHttpPostMetadataFillingProposalsByParentJobIdBulkAccept' as const;
export const TranscodeHttpPostMetadataFillingProposalsByParentJobIdBulkDiscard =
  'TranscodeHttpPostMetadataFillingProposalsByParentJobIdBulkDiscard' as const;
export const TranscodeHttpDeleteStoragesByStorageId =
  'TranscodeHttpDeleteStoragesByStorageId' as const;
export const TranscodeHttpGetStoragesByStorageIdEdgeTranscodeJobs =
  'TranscodeHttpGetStoragesByStorageIdEdgeTranscodeJobs' as const;
export const TranscodeHttpDeleteStoragesByStorageIdFilesByFileIdTranscode =
  'TranscodeHttpDeleteStoragesByStorageIdFilesByFileIdTranscode' as const;
export const TranscodeHttpGetStoragesByStorageIdTranscode =
  'TranscodeHttpGetStoragesByStorageIdTranscode' as const;
export const TranscodeHttpDeleteStoragesByStorageIdTranscodeByRecordId =
  'TranscodeHttpDeleteStoragesByStorageIdTranscodeByRecordId' as const;
export const TranscodeHttpGetStoragesByStorageIdTranscodeByRecordId =
  'TranscodeHttpGetStoragesByStorageIdTranscodeByRecordId' as const;
export const TranscodeHttpPostTranscode = 'TranscodeHttpPostTranscode' as const;
export const TranscodeHttpGetTranscodeQueue =
  'TranscodeHttpGetTranscodeQueue' as const;
export const TranscodeHttpGetTranscodeQueueSystem =
  'TranscodeHttpGetTranscodeQueueSystem' as const;
export const TranscodeHttpGetTranscodeByObjectTypeByObjectId =
  'TranscodeHttpGetTranscodeByObjectTypeByObjectId' as const;
export const TranscodeHttpGetTranscodeByObjectTypeByObjectIdVersionsByVersionId =
  'TranscodeHttpGetTranscodeByObjectTypeByObjectIdVersionsByVersionId' as const;
export const TranscodeHttpDeleteTranscodeByTranscodeJobId =
  'TranscodeHttpDeleteTranscodeByTranscodeJobId' as const;
export const TranscodeHttpGetTranscodeByTranscodeJobId =
  'TranscodeHttpGetTranscodeByTranscodeJobId' as const;
export const TranscodeHttpPostTranscodeByTranscodeJobIdPositionByPosition =
  'TranscodeHttpPostTranscodeByTranscodeJobIdPositionByPosition' as const;
export const TranscodeHttpPutTranscodeByTranscodeJobIdPriorityByPriority =
  'TranscodeHttpPutTranscodeByTranscodeJobIdPriorityByPriority' as const;
export const TranscodeHttpPostTranscribeAssetsByAssetIdProfilesDefault =
  'TranscodeHttpPostTranscribeAssetsByAssetIdProfilesDefault' as const;
export const TranscodeHttpPostTranscribeBulk =
  'TranscodeHttpPostTranscribeBulk' as const;

/**
 * Original schema `AbortStorageTranscodeJobsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-AbortStorageTranscodeJobsSchema}
 */
export interface TranscodeAbortStorageTranscodeJobsSchema {
  error_message?: string;
}
/**
 * Original schema `AnalyzeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-AnalyzeSchema}
 */
export interface TranscodeAnalyzeSchema {
  force?: boolean;
  force_type?: ('OVERWRITE' | 'APPEND') | null;
  service_name?: string;
}
/**
 * Original schema `AssetLinkData`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-AssetLinkData}
 */
export interface TranscodeAssetLinkData {
  site_name?: string;
  title?: string;
}
/**
 * Original schema `AssetLinkURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-AssetLinkURLSchema}
 */
export interface TranscodeAssetLinkURLSchema {
  url: string;
}
/**
 * Original schema `BulkActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-BulkActionSchema}
 */
export interface TranscodeBulkActionSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'saved_searches';
}
/**
 * Original schema `BulkAnalyzeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-BulkAnalyzeSchema}
 */
export interface TranscodeBulkAnalyzeSchema {
  force?: boolean;
  force_type?: ('OVERWRITE' | 'APPEND') | null;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'saved_searches';
  profile_id?: string;
}
/**
 * Original schema `BulkMetadataFillingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-BulkMetadataFillingSchema}
 */
export interface TranscodeBulkMetadataFillingSchema {
  auto_accept?: boolean;
  field_names?: string[] | null;
  /**
   * @minItems 1
   * @maxItems 100
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'saved_searches';
  overwrite?: boolean;
  view_id: string;
}
/**
 * Original schema `BulkTranscribeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-BulkTranscribeSchema}
 */
export interface TranscodeBulkTranscribeSchema {
  engine?: string | null;
  force?: boolean;
  language?: string | null;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'saved_searches';
  profile_id?: string;
  speakers?: number | null;
  summary?: boolean | null;
  topics_extraction?: boolean;
  translate_languages?: string[] | null;
}
/**
 * Original schema `EdgeThumbnailJobFieldSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeThumbnailJobFieldSchema}
 */
export interface TranscodeEdgeThumbnailJobFieldSchema {
  height?: number;
  id?: string;
  max_number?: number;
  min_interval?: number;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  timestamp?: number;
  width?: number;
}
/**
 * Original schema `EdgeTranscodeEndpointSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeTranscodeEndpointSchema}
 */
export interface TranscodeEdgeTranscodeEndpointSchema {
  data?: {
    [k: string]: unknown;
  };
  method?: string;
  storage_method?: string;
  type?: string;
  url: string;
}
/**
 * Original schema `EdgeTranscodeInputSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeTranscodeInputSchema}
 */
export interface TranscodeEdgeTranscodeInputSchema {
  asset_id?: string;
  closed_captions?: boolean;
  directory_path?: string;
  endpoint: TranscodeEdgeTranscodeEndpointSchema;
  file_id?: string;
  file_set_id?: string | null;
  format_id?: string | null;
  language?: string;
  original_asset_id?: string | null;
  original_name?: string;
  proxy_id?: string | null;
  storage_id?: string;
}
/**
 * Original schema `EdgeTranscodeJobFieldSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeTranscodeJobFieldSchema}
 */
export interface TranscodeEdgeTranscodeJobFieldSchema {
  height?: number;
  id?: string;
  width?: number;
}
/**
 * Original schema `EdgeTranscodeJobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeTranscodeJobSchema}
 */
export interface TranscodeEdgeTranscodeJobSchema {
  asset_id?: string;
  collection_id?: string;
  input: TranscodeEdgeTranscodeInputSchema;
  job_id?: string;
  job_steps?: TranscodeJobStep[];
  media_info?: string | null;
  thumbnail?: TranscodeEdgeThumbnailJobFieldSchema[];
  transcode?: TranscodeEdgeTranscodeJobFieldSchema[];
}
/**
 * Original schema `JobStep`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-JobStep}
 */
export interface TranscodeJobStep {
  date_created?: string;
  date_updated?: string;
  id?: string;
  label?: string;
  message?: string;
  status?: string;
}
/**
 * Original schema `EdgeTranscodeJobsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeTranscodeJobsSchema}
 */
export interface TranscodeEdgeTranscodeJobsSchema {
  objects?: TranscodeEdgeTranscodeJobSchema[];
}
/**
 * Original schema `EdgeTranscodeWorkerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeTranscodeWorkerSchema}
 */
export interface TranscodeEdgeTranscodeWorkerSchema {
  id?: string;
  last_update_date?: string;
  status: 'ACTIVE' | 'INACTIVE';
  storage_id: string;
}
/**
 * Original schema `EdgeTranscodeWorkersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeTranscodeWorkersSchema}
 */
export interface TranscodeEdgeTranscodeWorkersSchema {
  objects?: TranscodeEdgeTranscodeWorkerSchema[];
}
/**
 * Original schema `EndpointSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EndpointSchema}
 */
export interface TranscodeEndpointSchema {
  data?: {
    [k: string]: unknown;
  };
  headers?: {
    [k: string]: unknown;
  };
  method?: string;
  storage_method?: string;
  type?: string;
  url: string;
}
/**
 * Original schema `FacetBucketSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-FacetBucketSchema}
 */
export interface TranscodeFacetBucketSchema {
  doc_count?: number;
  key?: string;
}
/**
 * Original schema `FacetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-FacetSchema}
 */
export interface TranscodeFacetSchema {
  buckets?: TranscodeFacetBucketSchema[];
  doc_count_error_upper_bound?: number;
  sum_other_doc_count?: number;
}
/**
 * Original schema `GenerateCollectionKeyframeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-GenerateCollectionKeyframeSchema}
 */
export interface TranscodeGenerateCollectionKeyframeSchema {
  deleted_asset_id?: string;
  force?: boolean;
  /**
   * @minItems 0
   * @maxItems 4
   */
  specified_asset_ids?: string[];
  /**
   * @minItems 0
   * @maxItems 4
   */
  specified_keyframes?: TranscodeSpecifiedKeyframes[];
}
/**
 * Original schema `SpecifiedKeyframes`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-SpecifiedKeyframes}
 */
export interface TranscodeSpecifiedKeyframes {
  url: string;
}
/**
 * Original schema `InputSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-InputSchema}
 */
export interface TranscodeInputSchema {
  asset_id?: string | null;
  closed_captions?: boolean;
  collection_id?: string | null;
  directory_path?: string | null;
  endpoint: TranscodeEndpointSchema;
  engine?: string;
  file_id?: string | null;
  file_set_id?: string | null;
  format_id?: string | null;
  language?: string;
  original_asset_id?: string | null;
  original_name?: string;
  proxy_id?: string | null;
  storage_id?: string;
  update_proxy_mediainfo?: boolean | null;
  version_id?: string | null;
}
/**
 * Original schema `JobBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-JobBaseSchema}
 */
export interface TranscodeJobBaseSchema {
  asset_id?: string;
  collection_id?: string;
  input?: TranscodeInputSchema;
  job_id?: string;
  job_steps?: TranscodeJobStep[];
  media_info?: string | null;
  thumbnail?: TranscodeThumbnailJob[];
  transcode?: TranscodeTranscodeJob[];
}
/**
 * Original schema `ThumbnailJob`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-ThumbnailJob}
 */
export interface TranscodeThumbnailJob {
  height?: number;
  id?: string;
  max_number?: number;
  min_interval?: number;
  output_endpoint: TranscodeOutputEndpoint;
  set_as_custom_keyframe?: boolean;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  timestamp?: number;
  width?: number;
}
/**
 * Original schema `OutputEndpoint`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-OutputEndpoint}
 */
export interface TranscodeOutputEndpoint {
  headers?: {
    [k: string]: unknown;
  };
  key: string;
}
/**
 * Original schema `TranscodeJob`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeJob}
 */
export interface TranscodeTranscodeJob {
  height?: number;
  id?: string;
  output_endpoint: TranscodeOutputEndpoint;
  width?: number;
}
/**
 * Original schema `JobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-JobSchema}
 */
export interface TranscodeJobSchema {
  amazon_rekognition?: boolean;
  analysis_data?: {
    [k: string]: unknown;
  };
  analysis_query_default_service_account?: boolean;
  analyzed_before?: boolean;
  asset_id?: string;
  asset_link?: string;
  collection_id?: string;
  create_transcription?: boolean;
  delete_old_transcriptions?: boolean;
  force_transcoder?: string;
  google_cloud_video_intelligence?: boolean;
  input?: TranscodeInputSchema;
  job_id?: string;
  job_steps?: TranscodeJobStep[];
  language?: string | null;
  media_info?: string | null;
  overwrite?: boolean;
  priority?: number;
  speakers?: number | null;
  thumbnail?: TranscodeThumbnailJob[];
  transcode?: TranscodeTranscodeJob[];
  valid_transcoders?: TranscodeTranscoders[];
  version_id?: string;
}
/**
 * Original schema `Transcoders`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-Transcoders}
 */
export interface TranscodeTranscoders {
  id?: string;
  name?: string;
  settings?: {
    [k: string]: unknown;
  };
  type?: string;
}
/**
 * Original schema `JobStepSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-JobStepSchema}
 */
export interface TranscodeJobStepSchema {
  date_created?: string;
  date_updated?: string;
  id?: string;
  label?: string;
  message?: string;
  status?: string;
}
/**
 * Original schema `JobsPrioritySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-JobsPrioritySchema}
 */
export interface TranscodeJobsPrioritySchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  job_ids: string[];
  priority: number;
}
/**
 * Original schema `JobsStateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-JobsStateSchema}
 */
export interface TranscodeJobsStateSchema {
  action: 'ABORT' | 'RESTART';
  /**
   * @minItems 1
   * @maxItems 500
   */
  job_ids: string[];
}
/**
 * Original schema `LLMMetadataJobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-LLMMetadataJobSchema}
 */
export interface TranscodeLLMMetadataJobSchema {
  amazon_rekognition?: boolean;
  analysis_data?: {
    [k: string]: unknown;
  };
  analysis_query_default_service_account?: boolean;
  analyzed_before?: boolean;
  asset_id?: string;
  asset_link?: string;
  auto_accept?: boolean;
  automation_id?: string | null;
  collection_id?: string;
  create_transcription?: boolean;
  delete_old_transcriptions?: boolean;
  /**
   * @minItems 1
   */
  field_names: string[];
  force_transcoder?: string;
  google_cloud_video_intelligence?: boolean;
  group_ids?: string[];
  input?: TranscodeInputSchema;
  is_admin?: boolean;
  job_id?: string;
  job_steps?: TranscodeJobStepSchema[];
  language?: string | null;
  media_info?: string | null;
  overwrite?: boolean;
  parent_job_id?: string | null;
  priority?: number;
  requested_at?: number | null;
  speakers?: number | null;
  thumbnail?: TranscodeThumbnailJob[];
  transcode?: TranscodeTranscodeJob[];
  valid_transcoders?: TranscodeTranscoders[];
  version_id?: string;
  view_id: string;
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-ListObjectsSchema}
 */
export interface TranscodeListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `LocalStorageFileTranscodeJobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-LocalStorageFileTranscodeJobSchema}
 */
export interface TranscodeLocalStorageFileTranscodeJobSchema {
  asset_id: string;
  checksum?: string | null;
  collection_id?: string | null;
  component_ids?: string[];
  directory_path: string;
  file_id: string;
  file_set_id: string;
  filename: string;
  format_id: string;
  id?: string;
  job_id: string;
  metadata_update_only?: boolean | null;
  priority?: number;
  size: number;
  version_id: string;
}
/**
 * Original schema `LocalStorageFileTranscodeJobsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-LocalStorageFileTranscodeJobsSchema}
 */
export interface TranscodeLocalStorageFileTranscodeJobsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: TranscodeLocalStorageFileTranscodeJobSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `LocalTranscodeInputSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-LocalTranscodeInputSchema}
 */
export interface TranscodeLocalTranscodeInputSchema {
  asset_id: string;
  checksum?: string | null;
  closed_captions?: boolean;
  collection_id?: string | null;
  component_ids?: string[];
  directory_path: string;
  endpoint: TranscodeEndpointSchema;
  engine?: string;
  file_id: string;
  file_set_id: string;
  filename: string;
  format_id: string;
  language?: string;
  original_asset_id?: string | null;
  original_name?: string;
  proxy_id?: string | null;
  size: number;
  storage_id: string;
  update_proxy_mediainfo?: boolean | null;
  version_id: string;
}
/**
 * Original schema `LocalTranscodeJobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-LocalTranscodeJobSchema}
 */
export interface TranscodeLocalTranscodeJobSchema {
  amazon_rekognition?: boolean;
  analysis_data?: {
    [k: string]: unknown;
  };
  analysis_query_default_service_account?: boolean;
  analyzed_before?: boolean;
  asset_id?: string;
  asset_link?: string;
  collection_id?: string;
  create_transcription?: boolean;
  delete_old_transcriptions?: boolean;
  force_transcoder?: string;
  google_cloud_video_intelligence?: boolean;
  input: TranscodeLocalTranscodeInputSchema;
  job_id?: string;
  job_steps?: TranscodeJobStepSchema[];
  language?: string | null;
  media_info?: string | null;
  overwrite?: boolean;
  priority?: number;
  speakers?: number | null;
  thumbnail?: TranscodeThumbnailJob[];
  transcode?: TranscodeTranscodeJob[];
  valid_transcoders?: TranscodeTranscoders[];
  version_id?: string;
}
/**
 * Original schema `MetadataFillingProposalByAssetQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-MetadataFillingProposalByAssetQueryParamsSchema}
 */
export interface TranscodeMetadataFillingProposalByAssetQueryParamsSchema {
  version_id?: string | null;
}
/**
 * Original schema `MetadataFillingProposalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-MetadataFillingProposalSchema}
 */
export interface TranscodeMetadataFillingProposalSchema {
  asset_id?: string;
  bulk_review_in_progress?: boolean;
  date_created?: string;
  errors?: string[];
  field_names?: string[];
  field_values?: unknown;
  job_id?: string;
  parent_job_id?: string | null;
  review_status?: 'PENDING_USER' | 'ACCEPTED' | 'REJECTED';
  user_id?: string;
  version_id?: string | null;
  view_id?: string | null;
  warnings?: string[];
}
/**
 * Original schema `MetadataFillingResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-MetadataFillingResponseSchema}
 */
export interface TranscodeMetadataFillingResponseSchema {
  errors?: string[];
  /**
   * Map of field names to generated values. Values can be a string, a list of strings, or an object with 'value' and optional 'label' keys.
   */
  metadata_values?: {
    [k: string]: unknown;
  };
  warnings?: string[];
}
/**
 * Original schema `MetadataFillingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-MetadataFillingSchema}
 */
export interface TranscodeMetadataFillingSchema {
  auto_accept?: boolean;
  /**
   * @minItems 1
   */
  field_names: string[];
  overwrite?: boolean;
  view_id: string;
}
/**
 * Original schema `OutputEndpointSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-OutputEndpointSchema}
 */
export interface TranscodeOutputEndpointSchema {
  headers?: {
    [k: string]: unknown;
  };
  key: string;
}
/**
 * Original schema `ReindexQueueRecordSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-ReindexQueueRecordSchema}
 */
export interface TranscodeReindexQueueRecordSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `SpecifiedKeyframesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-SpecifiedKeyframesSchema}
 */
export interface TranscodeSpecifiedKeyframesSchema {
  url: string;
}
/**
 * Original schema `ThumbnailJobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-ThumbnailJobSchema}
 */
export interface TranscodeThumbnailJobSchema {
  height?: number;
  id?: string;
  max_number?: number;
  min_interval?: number;
  output_endpoint: TranscodeOutputEndpointSchema;
  set_as_custom_keyframe?: boolean;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  timestamp?: number;
  width?: number;
}
/**
 * Original schema `TranscodeESQueueRecordsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeESQueueRecordsSchema}
 */
export interface TranscodeTranscodeESQueueRecordsSchema {
  objects?: TranscodeTranscodeElasticQueueRecord[];
}
/**
 * Original schema `TranscodeElasticQueueRecord`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeElasticQueueRecord}
 */
export interface TranscodeTranscodeElasticQueueRecord {
  date_created?: string;
  date_updated?: string;
  id?: string;
  job_id?: string;
  object_id?: string;
  object_type?: string;
  priority?: string;
  queue?: string;
  retry_count?: string;
  status?: string;
  storage_id?: string;
  system_domain_id?: string;
  system_domain_timestamp?: string;
  system_name?: string;
  type?: string;
  user_id?: string;
  version_id?: string;
}
/**
 * Original schema `TranscodeElasticQueueRecordSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeElasticQueueRecordSchema}
 */
export interface TranscodeTranscodeElasticQueueRecordSchema {
  date_created?: string;
  date_updated?: string;
  id?: string;
  job_id?: string;
  object_id?: string;
  object_type?: string;
  priority?: string;
  queue?: string;
  retry_count?: string;
  status?: string;
  storage_id?: string;
  system_domain_id?: string;
  system_domain_timestamp?: string;
  system_name?: string;
  type?: string;
  user_id?: string;
  version_id?: string;
}
/**
 * Original schema `TranscodeJobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeJobSchema}
 */
export interface TranscodeTranscodeJobSchema {
  height?: number;
  id?: string;
  output_endpoint: TranscodeOutputEndpointSchema;
  width?: number;
}
/**
 * Original schema `TranscodeQueueObjectSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeQueueObjectSchema}
 */
export interface TranscodeTranscodeQueueObjectSchema {
  date_created?: string;
  date_updated?: string;
  id?: string;
  job_id?: string;
  priority?: number;
  retry_count?: number;
  status?: string;
  system_domain?: string;
  system_domain_id?: string;
  system_domain_timestamp?: number;
  system_name?: string;
  type?: string;
  user_id?: string;
}
/**
 * Original schema `TranscodeQueueRecordSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeQueueRecordSchema}
 */
export interface TranscodeTranscodeQueueRecordSchema {
  bytes_params?: unknown;
  date_created?: string;
  date_updated?: string;
  id?: string;
  job_id?: string | null;
  media_info?: string | null;
  object_id?: string | null;
  object_type?: string | null;
  params?: string | null;
  priority?: number | null;
  retry_count?: number | null;
  spec?: string | null;
  status?: string | null;
  system_domain_id?: string | null;
  system_name?: string;
  transcoder_id?: string | null;
  type?: string | null;
  user_id?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `TranscodeQueueSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeQueueSchema}
 */
export interface TranscodeTranscodeQueueSchema {
  facets?: {
    [k: string]: TranscodeFacetSchema;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: TranscodeTranscodeQueueObjectSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `TranscodeValidateMediaInfoSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeValidateMediaInfoSchema}
 */
export interface TranscodeTranscodeValidateMediaInfoSchema {
  filename?: string;
  media_info: string;
}
/**
 * Original schema `TranscodersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodersSchema}
 */
export interface TranscodeTranscodersSchema {
  id?: string;
  name?: string;
  settings?: {
    [k: string]: unknown;
  };
  type?: string;
}
/**
 * Original schema `TranscribeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscribeSchema}
 */
export interface TranscodeTranscribeSchema {
  engine?: string | null;
  force?: boolean;
  language?: string | null;
  profile_id?: string;
  speakers?: number | null;
  summary?: boolean | null;
  topics_extraction?: boolean;
  translate_languages?: string[] | null;
}
/**
 * Original schema `WildmokaPipelineTranscode`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-WildmokaPipelineTranscode}
 */
export interface TranscodeWildmokaPipelineTranscode {
  graph: {
    [k: string]: unknown;
  };
  parameters: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `WildmokaProtectTranscode`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-WildmokaProtectTranscode}
 */
export interface TranscodeWildmokaProtectTranscode {
  asset_id: string;
  callback_headers: {
    [k: string]: unknown;
  };
  component_type: string;
  container_id: string;
  create_file_callback_payload: {
    [k: string]: unknown;
  };
  create_file_callback_url: string;
  drm: string;
  drm_asset_id: string;
  frame_count: number;
  frame_rate: number;
  has_audio: boolean;
  height: number;
  input_url: string;
  monitor_job_id: string;
  proxy_id: string;
  segment_duration: number;
  update_file_status_callback_url: string;
  watermark: string;
  watermark_bit_profile: number;
  watermark_deep_fake: number;
  watermark_id: string | null;
  watermark_pixel_density: number;
  watermark_sp_height: number;
  watermark_sp_width: number;
  watermark_strength: number;
  watermark_super_pixel_density: number;
  width: number;
}
/**
 * Original schema `EdgeTranscodeWorkersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeTranscodeWorkersSchema}
 */
export interface TranscodeEdgeTranscodeWorkersSchemaWithId {
  objects: TranscodeEdgeTranscodeWorkerSchemaWithIdNullable[];
}
/**
 * Original schema `EdgeTranscodeWorkerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeTranscodeWorkerSchema}
 */
export interface TranscodeEdgeTranscodeWorkerSchemaWithIdNullable {
  id: string;
  last_update_date?: string | null;
  status: 'ACTIVE' | 'INACTIVE';
  storage_id: string;
}
/**
 * Original schema `EdgeTranscodeWorkerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeTranscodeWorkerSchema}
 */
export interface TranscodeEdgeTranscodeWorkerSchemaWithId {
  id: string;
  last_update_date?: string;
  status: 'ACTIVE' | 'INACTIVE';
  storage_id: string;
}
/**
 * Original schema `MetadataFillingProposalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-MetadataFillingProposalSchema}
 */
export interface TranscodeMetadataFillingProposalSchemaNullable {
  asset_id?: string | null;
  bulk_review_in_progress?: boolean | null;
  date_created?: string | null;
  errors?: string[] | null;
  field_names?: string[] | null;
  field_values?: unknown;
  job_id?: string | null;
  parent_job_id?: string | null;
  review_status?: ('PENDING_USER' | 'ACCEPTED' | 'REJECTED') | null;
  user_id?: string | null;
  version_id?: string | null;
  view_id?: string | null;
  warnings?: string[] | null;
}
/**
 * Original schema `EdgeTranscodeJobsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeTranscodeJobsSchema}
 */
export interface TranscodeEdgeTranscodeJobsSchemaWithId {
  objects: TranscodeEdgeTranscodeJobSchemaNullable[];
}
/**
 * Original schema `EdgeTranscodeJobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-EdgeTranscodeJobSchema}
 */
export interface TranscodeEdgeTranscodeJobSchemaNullable {
  asset_id?: string | null;
  collection_id?: string | null;
  input: TranscodeEdgeTranscodeInputSchema;
  job_id?: string | null;
  job_steps?: TranscodeJobStep[] | null;
  media_info?: string | null;
  thumbnail?: TranscodeEdgeThumbnailJobFieldSchema[] | null;
  transcode?: TranscodeEdgeTranscodeJobFieldSchema[] | null;
}
/**
 * Original schema `LocalStorageFileTranscodeJobsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-LocalStorageFileTranscodeJobsSchema}
 */
export interface TranscodeLocalStorageFileTranscodeJobsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: TranscodeLocalStorageFileTranscodeJobSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `LocalStorageFileTranscodeJobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-LocalStorageFileTranscodeJobSchema}
 */
export interface TranscodeLocalStorageFileTranscodeJobSchemaWithIdNullable {
  asset_id: string;
  checksum?: string | null;
  collection_id?: string | null;
  component_ids?: string[] | null;
  directory_path: string;
  file_id: string;
  file_set_id: string;
  filename: string;
  format_id: string;
  id: string;
  job_id: string;
  metadata_update_only?: boolean | null;
  priority?: number | null;
  size: number;
  version_id: string;
}
/**
 * Original schema `LocalStorageFileTranscodeJobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-LocalStorageFileTranscodeJobSchema}
 */
export interface TranscodeLocalStorageFileTranscodeJobSchemaWithId {
  asset_id: string;
  checksum?: string | null;
  collection_id?: string | null;
  component_ids?: string[];
  directory_path: string;
  file_id: string;
  file_set_id: string;
  filename: string;
  format_id: string;
  id: string;
  job_id: string;
  metadata_update_only?: boolean | null;
  priority?: number;
  size: number;
  version_id: string;
}
/**
 * Original schema `TranscodeQueueSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeQueueSchema}
 */
export interface TranscodeTranscodeQueueSchemaWithId {
  facets?: {
    [k: string]: TranscodeFacetSchema;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: TranscodeTranscodeQueueObjectSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `TranscodeQueueObjectSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeQueueObjectSchema}
 */
export interface TranscodeTranscodeQueueObjectSchemaWithIdNullable {
  date_created?: string | null;
  date_updated?: string | null;
  id: string;
  job_id?: string | null;
  priority?: number | null;
  retry_count?: number | null;
  status?: string | null;
  system_domain?: string | null;
  system_domain_id?: string | null;
  system_domain_timestamp?: number | null;
  system_name?: string | null;
  type?: string | null;
  user_id?: string | null;
}
/**
 * Original schema `TranscodeQueueObjectSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeQueueObjectSchema}
 */
export interface TranscodeTranscodeQueueObjectSchemaWithId {
  date_created?: string;
  date_updated?: string;
  id: string;
  job_id?: string;
  priority?: number;
  retry_count?: number;
  status?: string;
  system_domain?: string;
  system_domain_id?: string;
  system_domain_timestamp?: number;
  system_name?: string;
  type?: string;
  user_id?: string;
}
/**
 * Original schema `TranscodeESQueueRecordsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeESQueueRecordsSchema}
 */
export interface TranscodeTranscodeESQueueRecordsSchemaWithId {
  objects: TranscodeTranscodeElasticQueueRecordWithIdNullable[];
}
/**
 * Original schema `TranscodeElasticQueueRecord`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeElasticQueueRecord}
 */
export interface TranscodeTranscodeElasticQueueRecordWithIdNullable {
  date_created?: string | null;
  date_updated?: string | null;
  id: string;
  job_id?: string | null;
  object_id?: string | null;
  object_type?: string | null;
  priority?: string | null;
  queue?: string | null;
  retry_count?: string | null;
  status?: string | null;
  storage_id?: string | null;
  system_domain_id?: string | null;
  system_domain_timestamp?: string | null;
  system_name?: string | null;
  type?: string | null;
  user_id?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `TranscodeElasticQueueRecord`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-TranscodeElasticQueueRecord}
 */
export interface TranscodeTranscodeElasticQueueRecordWithId {
  date_created?: string;
  date_updated?: string;
  id: string;
  job_id?: string;
  object_id?: string;
  object_type?: string;
  priority?: string;
  queue?: string;
  retry_count?: string;
  status?: string;
  storage_id?: string;
  system_domain_id?: string;
  system_domain_timestamp?: string;
  system_name?: string;
  type?: string;
  user_id?: string;
  version_id?: string;
}
/**
 * Original schema `JobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#model-JobSchema}
 */
export interface TranscodeJobSchemaNullable {
  amazon_rekognition?: boolean | null;
  analysis_data?: {
    [k: string]: unknown;
  } | null;
  analysis_query_default_service_account?: boolean | null;
  analyzed_before?: boolean | null;
  asset_id?: string | null;
  asset_link?: string | null;
  collection_id?: string | null;
  create_transcription?: boolean | null;
  delete_old_transcriptions?: boolean | null;
  force_transcoder?: string | null;
  google_cloud_video_intelligence?: boolean | null;
  input?: TranscodeInputSchema | null;
  job_id?: string | null;
  job_steps?: TranscodeJobStep[] | null;
  language?: string | null;
  media_info?: string | null;
  overwrite?: boolean | null;
  priority?: number | null;
  speakers?: number | null;
  thumbnail?: TranscodeThumbnailJob[] | null;
  transcode?: TranscodeTranscodeJob[] | null;
  valid_transcoders?: TranscodeTranscoders[] | null;
  version_id?: string | null;
}

/**
 * `POST /v1/analyze/assets/{asset_id}/`
 *
 * Start a job that sends an asset for analysis
 *
 * Required roles:
 *  - can_analyze_content
 *
 * Responses
 * - 200 - Returns a definition of the started job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - System analysis service account doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_analyze_assets__asset_id__}
 * @deprecated
 */
export const httpPostAnalyzeAssetsByAssetId = (
  assetId: string,
  body: TranscodeAnalyzeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostAnalyzeAssetsByAssetId,
  method: httpMethod.post,
  url: `/API/transcode/v1/analyze/assets/${encodeURIComponent(assetId)}/`,
  params: { assetId },
  body,
  headers,
});

/**
 * `POST /v1/analyze/assets/{asset_id}/profiles/default/`
 *
 * Start a job that sends an asset for analysis with a default analysis profile
 *
 * Required roles:
 *  - can_analyze_content
 *
 * Responses
 * - 201 - Returns a definition of the started job
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_analyze_assets__asset_id__profiles_default_}
 */
export const httpPostAnalyzeAssetsByAssetIdProfilesDefault = (
  assetId: string,
  body: TranscodeAnalyzeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostAnalyzeAssetsByAssetIdProfilesDefault,
  method: httpMethod.post,
  url: `/API/transcode/v1/analyze/assets/${encodeURIComponent(assetId)}/profiles/default/`,
  params: { assetId },
  body,
  headers,
});

/**
 * `POST /v1/analyze/assets/{asset_id}/profiles/default/{media_type}/`
 *
 * Start a job that sends an asset for analysis
 *
 * with a default analysis profile of specified media typewith a default analysis profile of specified media type
 * Required roles:
 *  - can_analyze_content
 *
 * Responses
 * - 201 - Returns a definition of the started job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Analysis account/profile was not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_analyze_assets__asset_id__profiles_default__media_type__}
 */
export const httpPostAnalyzeAssetsByAssetIdProfilesDefaultByMediaType = (
  assetId: string,
  mediaType: string,
  body: TranscodeAnalyzeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostAnalyzeAssetsByAssetIdProfilesDefaultByMediaType,
  method: httpMethod.post,
  url: `/API/transcode/v1/analyze/assets/${encodeURIComponent(assetId)}/profiles/default/${encodeURIComponent(mediaType)}/`,
  params: { assetId, mediaType },
  body,
  headers,
});

/**
 * `POST /v1/analyze/assets/{asset_id}/profiles/{profile_id}/`
 *
 * Start a job that sends an asset for analysis with a custom analysis profile
 *
 * Required roles:
 *  - can_analyze_content
 *
 * Responses
 * - 201 - Returns a definition of the started job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Analysis account/profile was not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_analyze_assets__asset_id__profiles__profile_id__}
 */
export const httpPostAnalyzeAssetsByAssetIdProfilesByProfileId = (
  assetId: string,
  profileId: string,
  body: TranscodeAnalyzeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostAnalyzeAssetsByAssetIdProfilesByProfileId,
  method: httpMethod.post,
  url: `/API/transcode/v1/analyze/assets/${encodeURIComponent(assetId)}/profiles/${encodeURIComponent(profileId)}/`,
  params: { assetId, profileId },
  body,
  headers,
});

/**
 * `POST /v1/analyze/bulk/`
 *
 * Start a job that sends objects for analysis using a custom analysis profile
 *
 * Required roles:
 *  - can_analyze_content
 *
 * Responses
 * - 201 - Returns a definition of the started job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Analysis account/profile was not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_analyze_bulk_}
 */
export const httpPostAnalyzeBulk = (
  body: TranscodeBulkAnalyzeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostAnalyzeBulk,
  method: httpMethod.post,
  url: '/API/transcode/v1/analyze/bulk/',

  body,
  headers,
});

/**
 * `POST /v1/edge_transcode/jobs/{job_id}/acknowledge/`
 *
 * Acknowledge an edge transcode job
 *
 * Required roles:
 *  - can_read_transcode_jobs
 *
 * Responses
 * - 200 - Acknowledge an edge transcode job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Edge transcode job doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_edge_transcode_jobs__job_id__acknowledge_}
 */
export const httpPostEdgeTranscodeJobsByJobIdAcknowledge = (
  jobId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostEdgeTranscodeJobsByJobIdAcknowledge,
  method: httpMethod.post,
  url: `/API/transcode/v1/edge_transcode/jobs/${encodeURIComponent(jobId)}/acknowledge/`,
  params: { jobId },
  headers,
});

export interface TranscodeHttpGetEdgeTranscodeWorkersQuery {
  /**
   * The number of items for each page (max 100)
   */
  per_page?: number;
  /**
   * ID of a last edge transcode worker on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/edge_transcode/workers/`
 *
 * Get edge transcode workers
 *
 * Required roles:
 *  - is_storage_worker
 * - can_read_transcoders
 *
 * Responses
 * - 200 - Returns edge transcode workers
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link TranscodeEdgeTranscodeWorkersSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/get_v1_edge_transcode_workers_}
 */
export const httpGetEdgeTranscodeWorkers = (
  query?: TranscodeHttpGetEdgeTranscodeWorkersQuery,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpGetEdgeTranscodeWorkers,
  method: httpMethod.get,
  url: '/API/transcode/v1/edge_transcode/workers/',

  query,
  headers,
});

/**
 * `POST /v1/edge_transcode/workers/`
 *
 * Create a new edge transcode worker
 *
 * Required roles:
 *  - is_storage_worker
 * - can_write_transcoders
 *
 * Responses
 * - 200 - Returns an edge transcode worker
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link TranscodeEdgeTranscodeWorkerSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_edge_transcode_workers_}
 */
export const httpPostEdgeTranscodeWorkers = (
  body: TranscodeEdgeTranscodeWorkerSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostEdgeTranscodeWorkers,
  method: httpMethod.post,
  url: '/API/transcode/v1/edge_transcode/workers/',

  body,
  headers,
});

/**
 * `DELETE /v1/edge_transcode/workers/{worker_id}/`
 *
 * Delete an edge transcode worker
 *
 * Required roles:
 *  - is_storage_worker
 * - can_write_transcoders
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Edge transcode worker doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/delete_v1_edge_transcode_workers__worker_id__}
 */
export const httpDeleteEdgeTranscodeWorkersByWorkerId = (
  workerId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpDeleteEdgeTranscodeWorkersByWorkerId,
  method: httpMethod.delete,
  url: `/API/transcode/v1/edge_transcode/workers/${encodeURIComponent(workerId)}/`,
  params: { workerId },
  headers,
});

/**
 * `GET /v1/edge_transcode/workers/{worker_id}/`
 *
 * Get an edge transcode worker
 *
 * Required roles:
 *  - is_storage_worker
 * - can_read_transcoders
 *
 * Responses
 * - 200 - Returns an edge transcode worker
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Edge transcode worker doesn't exist
 *
 * Response {@link TranscodeEdgeTranscodeWorkerSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/get_v1_edge_transcode_workers__worker_id__}
 */
export const httpGetEdgeTranscodeWorkersByWorkerId = (
  workerId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpGetEdgeTranscodeWorkersByWorkerId,
  method: httpMethod.get,
  url: `/API/transcode/v1/edge_transcode/workers/${encodeURIComponent(workerId)}/`,
  params: { workerId },
  headers,
});

export type TranscodeEdgeTranscodeWorkerSchemaPartial =
  Partial<TranscodeEdgeTranscodeWorkerSchema>;

/**
 * `PATCH /v1/edge_transcode/workers/{worker_id}/`
 *
 * Update an edge transcode worker
 *
 * Required roles:
 *  - is_storage_worker
 * - can_write_transcoders
 *
 * Responses
 * - 200 - Returns an edge transcode worker that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Edge transcode worker doesn't exist
 *
 * Response {@link TranscodeEdgeTranscodeWorkerSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/patch_v1_edge_transcode_workers__worker_id__}
 */
export const httpPatchEdgeTranscodeWorkersByWorkerId = (
  workerId: string,
  body: TranscodeEdgeTranscodeWorkerSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPatchEdgeTranscodeWorkersByWorkerId,
  method: httpMethod.patch,
  url: `/API/transcode/v1/edge_transcode/workers/${encodeURIComponent(workerId)}/`,
  params: { workerId },
  body,
  headers,
});

/**
 * `PUT /v1/edge_transcode/workers/{worker_id}/`
 *
 * Update an edge transcode worker
 *
 * Required roles:
 *  - is_storage_worker
 * - can_write_transcoders
 *
 * Responses
 * - 200 - Returns an edge transcode worker that was updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Edge transcode worker doesn't exist
 *
 * Response {@link TranscodeEdgeTranscodeWorkerSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/put_v1_edge_transcode_workers__worker_id__}
 */
export const httpPutEdgeTranscodeWorkersByWorkerId = (
  workerId: string,
  body: TranscodeEdgeTranscodeWorkerSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPutEdgeTranscodeWorkersByWorkerId,
  method: httpMethod.put,
  url: `/API/transcode/v1/edge_transcode/workers/${encodeURIComponent(workerId)}/`,
  params: { workerId },
  body,
  headers,
});

/**
 * `POST /v1/keyframes/collections/{collection_id}/`
 *
 * Start a job that creates a collection keyframe
 *
 * Required roles:
 *  - can_write_transcode_jobs
 *
 * Responses
 * - 200 - Returns a definition of the started job
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_keyframes_collections__collection_id__}
 */
export const httpPostKeyframesCollectionsByCollectionId = (
  collectionId: string,
  body: TranscodeGenerateCollectionKeyframeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostKeyframesCollectionsByCollectionId,
  method: httpMethod.post,
  url: `/API/transcode/v1/keyframes/collections/${encodeURIComponent(collectionId)}/`,
  params: { collectionId },
  body,
  headers,
});

/**
 * `POST /v1/keyframes/playlists/{playlist_id}/`
 *
 * Start a job that creates a playlist keyframe
 *
 * Required roles:
 *  - can_write_transcode_jobs
 *
 * Responses
 * - 200 - Returns a definition of the started job
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_keyframes_playlists__playlist_id__}
 */
export const httpPostKeyframesPlaylistsByPlaylistId = (
  playlistId: string,
  body: TranscodeGenerateCollectionKeyframeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostKeyframesPlaylistsByPlaylistId,
  method: httpMethod.post,
  url: `/API/transcode/v1/keyframes/playlists/${encodeURIComponent(playlistId)}/`,
  params: { playlistId },
  body,
  headers,
});

/**
 * `POST /v1/metadata_filling/assets/{asset_id}/versions/{version_id}/`
 *
 * Enqueue enriched metadata filling for a single asset version
 *
 * Required roles:
 *  - can_trigger_metadata_ai_filling
 * - can_write_metadata_values
 *
 * Responses
 * - 201 - Returns the job status and job ID
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - AI metadata filling is not enabled for this domain
 * - 409 - A pending AI metadata review already exists for this asset version
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_metadata_filling_assets__asset_id__versions__version_id__}
 */
export const httpPostMetadataFillingAssetsByAssetIdVersionsByVersionId = (
  assetId: string,
  versionId: string,
  body: TranscodeMetadataFillingSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostMetadataFillingAssetsByAssetIdVersionsByVersionId,
  method: httpMethod.post,
  url: `/API/transcode/v1/metadata_filling/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/`,
  params: { assetId, versionId },
  body,
  headers,
});

/**
 * `POST /v1/metadata_filling/bulk/`
 *
 * Run bulk AI metadata filling
 *
 * Required roles:
 *  - can_trigger_metadata_ai_filling
 * - can_write_metadata_values
 *
 * Responses
 * - 201 - Returns the job status and job ID
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - AI metadata filling is not enabled for this domain
 * - 404 - Metadata view doesn't exist
 * - 502 - The metadata view could not be read, the request may be retried
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_metadata_filling_bulk_}
 */
export const httpPostMetadataFillingBulk = (
  body: TranscodeBulkMetadataFillingSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostMetadataFillingBulk,
  method: httpMethod.post,
  url: '/API/transcode/v1/metadata_filling/bulk/',

  body,
  headers,
});

/**
 * `GET /v1/metadata_filling/proposals/assets/{asset_id}/versions/{version_id}/`
 *
 * Fetch the caller's PENDING_USER LLM proposal for an asset version
 *
 * Required roles:
 *  - can_read_metadata_values
 *
 * Responses
 * - 200 - The caller's PENDING_USER proposal for the (asset, version)
 * - 401 - Token is invalid
 * - 404 - No pending proposal owned by the caller for this (asset, version)
 *
 * Response {@link TranscodeMetadataFillingProposalSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/get_v1_metadata_filling_proposals_assets__asset_id__versions__version_id__}
 */
export const httpGetMetadataFillingProposalsAssetsByAssetIdVersionsByVersionId =
  (assetId: string, versionId: string, headers?: IconikApiHeaders) => ({
    id: TranscodeHttpGetMetadataFillingProposalsAssetsByAssetIdVersionsByVersionId,
    method: httpMethod.get,
    url: `/API/transcode/v1/metadata_filling/proposals/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/`,
    params: { assetId, versionId },
    headers,
  });

/**
 * `GET /v1/metadata_filling/proposals/{job_id}/`
 *
 * Fetch the LLM-generated metadata proposal for a completed sub-job
 *
 * Required roles:
 *  - can_read_metadata_values
 *
 * Responses
 * - 200 - The stored proposal
 * - 401 - Token is invalid
 * - 403 - Caller does not own this proposal and is not an admin
 * - 404 - No proposal found for this job_id
 *
 * Response {@link TranscodeMetadataFillingProposalSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/get_v1_metadata_filling_proposals__job_id__}
 */
export const httpGetMetadataFillingProposalsByJobId = (
  jobId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpGetMetadataFillingProposalsByJobId,
  method: httpMethod.get,
  url: `/API/transcode/v1/metadata_filling/proposals/${encodeURIComponent(jobId)}/`,
  params: { jobId },
  headers,
});

/**
 * `POST /v1/metadata_filling/proposals/{job_id}/accept/`
 *
 * Accept an AI metadata-filling proposal
 *
 * Required roles:
 *  - can_write_metadata_values
 *
 * Responses
 * - 200 - Returns the updated proposal
 * - 401 - Token is invalid
 * - 403 - Caller does not own this proposal
 * - 404 - Proposal not found
 * - 409 - Proposal is no longer pending review, or its job is being bulk reviewed
 * - 502 - The job could not be updated, the request may be retried
 *
 * Response {@link TranscodeMetadataFillingProposalSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_metadata_filling_proposals__job_id__accept_}
 */
export const httpPostMetadataFillingProposalsByJobIdAccept = (
  jobId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostMetadataFillingProposalsByJobIdAccept,
  method: httpMethod.post,
  url: `/API/transcode/v1/metadata_filling/proposals/${encodeURIComponent(jobId)}/accept/`,
  params: { jobId },
  headers,
});

/**
 * `POST /v1/metadata_filling/proposals/{job_id}/discard/`
 *
 * Discard an AI metadata-filling proposal
 *
 * Required roles:
 *  - can_write_metadata_values
 *
 * Responses
 * - 200 - Returns the updated proposal
 * - 401 - Token is invalid
 * - 403 - Caller does not own this proposal
 * - 404 - Proposal not found
 * - 409 - Proposal is no longer pending review, or its job is being bulk reviewed
 * - 502 - The job could not be updated, the request may be retried
 *
 * Response {@link TranscodeMetadataFillingProposalSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_metadata_filling_proposals__job_id__discard_}
 */
export const httpPostMetadataFillingProposalsByJobIdDiscard = (
  jobId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostMetadataFillingProposalsByJobIdDiscard,
  method: httpMethod.post,
  url: `/API/transcode/v1/metadata_filling/proposals/${encodeURIComponent(jobId)}/discard/`,
  params: { jobId },
  headers,
});

/**
 * `POST /v1/metadata_filling/proposals/{job_id}/regenerate/`
 *
 * Regenerate an AI metadata-filling proposal
 *
 * Required roles:
 *  - can_write_metadata_values
 *
 * Responses
 * - 201 - Returns the fresh job_id (status WAITING)
 * - 401 - Token is invalid
 * - 403 - Caller does not own this proposal or AI metadata filling is not enabled
 * - 404 - Proposal not found
 * - 409 - Proposal is no longer pending review, its job is being bulk reviewed, or
another job is already in flight for this asset version
 * - 502 - The job could not be read or updated, the request may be retried
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_metadata_filling_proposals__job_id__regenerate_}
 */
export const httpPostMetadataFillingProposalsByJobIdRegenerate = (
  jobId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostMetadataFillingProposalsByJobIdRegenerate,
  method: httpMethod.post,
  url: `/API/transcode/v1/metadata_filling/proposals/${encodeURIComponent(jobId)}/regenerate/`,
  params: { jobId },
  headers,
});

/**
 * `POST /v1/metadata_filling/proposals/{parent_job_id}/bulk/accept/`
 *
 * Accept every pending AI metadata-filling proposal under a bulk job
 *
 * <br/>Each proposal's values are written to the asset through the job's metadata view before<br/>the proposal is accepted. Only the user who triggered the job may run this. A regenerated<br/>proposal belongs to a new standalone job and is not part of this review.<br/>Each proposal's values are written to the asset through the job's metadata view before<br/>the proposal is accepted. Only the user who triggered the job may run this. A regenerated<br/>proposal belongs to a new standalone job and is not part of this review.
 * Required roles:
 *  - can_write_metadata_values
 *
 * Responses
 * - 202 - The proposals will be accepted in the background
 * - 400 - Not a metadata filling job, no children, or no children pending review
 * - 401 - Token is invalid
 * - 403 - AI metadata filling is not enabled, or the caller did not trigger the job
 * - 404 - Parent job not found
 * - 409 - The job is still running, or a bulk review of its proposals is in progress
 * - 502 - The parent job or its children could not be read, the request may be retried
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_metadata_filling_proposals__parent_job_id__bulk_accept_}
 */
export const httpPostMetadataFillingProposalsByParentJobIdBulkAccept = (
  parentJobId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostMetadataFillingProposalsByParentJobIdBulkAccept,
  method: httpMethod.post,
  url: `/API/transcode/v1/metadata_filling/proposals/${encodeURIComponent(parentJobId)}/bulk/accept/`,
  params: { parentJobId },
  headers,
});

/**
 * `POST /v1/metadata_filling/proposals/{parent_job_id}/bulk/discard/`
 *
 * Discard every pending AI metadata-filling proposal under a bulk job
 *
 * <br/>Only the user who triggered the job may run this. A regenerated proposal belongs to a<br/>new standalone job and is not part of this review.<br/>Only the user who triggered the job may run this. A regenerated proposal belongs to a<br/>new standalone job and is not part of this review.
 * Required roles:
 *  - can_write_metadata_values
 *
 * Responses
 * - 202 - The proposals will be discarded in the background
 * - 400 - Not a metadata filling job, no children, or no children pending review
 * - 401 - Token is invalid
 * - 403 - AI metadata filling is not enabled, or the caller did not trigger the job
 * - 404 - Parent job not found
 * - 409 - The job is still running, or a bulk review of its proposals is in progress
 * - 502 - The parent job or its children could not be read, the request may be retried
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_metadata_filling_proposals__parent_job_id__bulk_discard_}
 */
export const httpPostMetadataFillingProposalsByParentJobIdBulkDiscard = (
  parentJobId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostMetadataFillingProposalsByParentJobIdBulkDiscard,
  method: httpMethod.post,
  url: `/API/transcode/v1/metadata_filling/proposals/${encodeURIComponent(parentJobId)}/bulk/discard/`,
  params: { parentJobId },
  headers,
});

/**
 * `DELETE /v1/storages/{storage_id}/`
 *
 * Cancel all transcode jobs linked to the storage
 *
 * Required roles:
 *  - can_delete_transcode_jobs
 *
 * Responses
 * - 200 - Successfully scheduled operation
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/delete_v1_storages__storage_id__}
 */
export const httpDeleteStoragesByStorageId = (
  storageId: string,
  body: TranscodeAbortStorageTranscodeJobsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpDeleteStoragesByStorageId,
  method: httpMethod.delete,
  url: `/API/transcode/v1/storages/${encodeURIComponent(storageId)}/`,
  params: { storageId },
  body,
  headers,
});

export interface TranscodeHttpGetStoragesByStorageIdEdgeTranscodeJobsQuery {
  /**
   * The max number of items to fetch
   */
  limit?: number;
}

/**
 * `GET /v1/storages/{storage_id}/edge_transcode/jobs/`
 *
 * Get edge transcode jobs from the job queue
 *
 * Required roles:
 *  - can_read_transcode_jobs
 *
 * Responses
 * - 200 - Returns edge transcode jobs
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link TranscodeEdgeTranscodeJobsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/get_v1_storages__storage_id__edge_transcode_jobs_}
 */
export const httpGetStoragesByStorageIdEdgeTranscodeJobs = (
  storageId: string,
  query?: TranscodeHttpGetStoragesByStorageIdEdgeTranscodeJobsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpGetStoragesByStorageIdEdgeTranscodeJobs,
  method: httpMethod.get,
  url: `/API/transcode/v1/storages/${encodeURIComponent(storageId)}/edge_transcode/jobs/`,
  params: { storageId },
  query,
  headers,
});

/**
 * `DELETE /v1/storages/{storage_id}/files/{file_id}/transcode/`
 *
 * Delete local storage transcode job.
 *
 * Required roles:
 *  - can_read_transcode_jobs
 *
 * Responses
 * - 204 - Transcode job was deleted
 * - 400 - Bad request
 * - 404 - Transcode job does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/delete_v1_storages__storage_id__files__file_id__transcode_}
 * @deprecated
 */
export const httpDeleteStoragesByStorageIdFilesByFileIdTranscode = (
  storageId: string,
  fileId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpDeleteStoragesByStorageIdFilesByFileIdTranscode,
  method: httpMethod.delete,
  url: `/API/transcode/v1/storages/${encodeURIComponent(storageId)}/files/${encodeURIComponent(fileId)}/transcode/`,
  params: { storageId, fileId },
  headers,
});

export interface TranscodeHttpGetStoragesByStorageIdTranscodeQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last transcode job entity on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/storages/{storage_id}/transcode/`
 *
 * Get pending local storage transcode jobs.
 *
 * Required roles:
 *  - can_read_transcode_jobs
 *
 * Responses
 * - 200 - Returns pending transcode jobs to be handled
 * - 400 - Bad request
 *
 * Response {@link TranscodeLocalStorageFileTranscodeJobsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/get_v1_storages__storage_id__transcode_}
 */
export const httpGetStoragesByStorageIdTranscode = (
  storageId: string,
  query?: TranscodeHttpGetStoragesByStorageIdTranscodeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpGetStoragesByStorageIdTranscode,
  method: httpMethod.get,
  url: `/API/transcode/v1/storages/${encodeURIComponent(storageId)}/transcode/`,
  params: { storageId },
  query,
  headers,
});

/**
 * `DELETE /v1/storages/{storage_id}/transcode/{record_id}/`
 *
 * Delete local storage transcode job.
 *
 * Required roles:
 *  - can_read_transcode_jobs
 *
 * Responses
 * - 204 - Transcode job was deleted
 * - 400 - Bad request
 * - 404 - Transcode job does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/delete_v1_storages__storage_id__transcode__record_id__}
 */
export const httpDeleteStoragesByStorageIdTranscodeByRecordId = (
  storageId: string,
  recordId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpDeleteStoragesByStorageIdTranscodeByRecordId,
  method: httpMethod.delete,
  url: `/API/transcode/v1/storages/${encodeURIComponent(storageId)}/transcode/${encodeURIComponent(recordId)}/`,
  params: { storageId, recordId },
  headers,
});

/**
 * `GET /v1/storages/{storage_id}/transcode/{record_id}/`
 *
 * Get local storage transcode job.
 *
 * Required roles:
 *  - can_read_transcode_jobs
 *
 * Responses
 * - 200 - Returns pending transcode job to be handled
 * - 400 - Bad request
 * - 404 - Transcode job does not exist
 *
 * Response {@link TranscodeLocalStorageFileTranscodeJobSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/get_v1_storages__storage_id__transcode__record_id__}
 */
export const httpGetStoragesByStorageIdTranscodeByRecordId = (
  storageId: string,
  recordId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpGetStoragesByStorageIdTranscodeByRecordId,
  method: httpMethod.get,
  url: `/API/transcode/v1/storages/${encodeURIComponent(storageId)}/transcode/${encodeURIComponent(recordId)}/`,
  params: { storageId, recordId },
  headers,
});

/**
 * `POST /v1/transcode/`
 *
 * Starts a new transcode.
 *
 * Use /API/files/v1/assets/ID/files/ID/keyframes insteadUse /API/files/v1/assets/ID/files/ID/keyframes instead
 * Required roles:
 *  - can_write_transcode_jobs
 *
 * Responses
 * - 200 - Returns a definition of the started job
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link TranscodeJobSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_transcode_}
 * @deprecated
 */
export const httpPostTranscode = (
  body: TranscodeJobSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostTranscode,
  method: httpMethod.post,
  url: '/API/transcode/v1/transcode/',

  body,
  headers,
});

export interface TranscodeHttpGetTranscodeQueueQuery {
  per_page?: number;
  page?: number;
  /**
   * A comma separated list of fieldnames without spaces. object_type,user_id,retry_count,priority,type,status
   */
  sort?: string;
}

/**
 * `GET /v1/transcode/queue/`
 *
 * Get all the statuses of the queued transcode jobs
 *
 * Required roles:
 *  - can_read_transcode_jobs
 *
 * Responses
 * - 200 - Returns the status of all ongoing transcode jobs
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Page does not exist
 *
 * Response {@link TranscodeTranscodeQueueSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/get_v1_transcode_queue_}
 */
export const httpGetTranscodeQueue = (
  query?: TranscodeHttpGetTranscodeQueueQuery,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpGetTranscodeQueue,
  method: httpMethod.get,
  url: '/API/transcode/v1/transcode/queue/',

  query,
  headers,
});

export interface TranscodeHttpGetTranscodeQueueSystemQuery {
  per_domain_id?: boolean;
  per_page?: number;
  page?: number;
  sort?: string;
}

/**
 * `GET /v1/transcode/queue/system/`
 *
 * Get the status of the transcode job queues
 *
 *
 * Responses
 * - 200 - Returns the status of all ongoing transcode job queues for all domains
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Endpoint only accessible to system admins
 * - 404 - Page does not exist
 *
 * Response {@link TranscodeTranscodeQueueSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/get_v1_transcode_queue_system_}
 */
export const httpGetTranscodeQueueSystem = (
  query?: TranscodeHttpGetTranscodeQueueSystemQuery,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpGetTranscodeQueueSystem,
  method: httpMethod.get,
  url: '/API/transcode/v1/transcode/queue/system/',

  query,
  headers,
});

/**
 * `GET /v1/transcode/{object_type}/{object_id}/`
 *
 * Returns list of transcode queue records by object_id
 *
 * Required roles:
 *  - can_read_transcode_jobs
 *
 * Responses
 * - 200 - Returns list of transcode queue records
 * - 400 - Bad request - malformed parameters
 *
 * Response {@link TranscodeTranscodeESQueueRecordsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/get_v1_transcode__object_type___object_id__}
 */
export const httpGetTranscodeByObjectTypeByObjectId = (
  objectType: string,
  objectId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpGetTranscodeByObjectTypeByObjectId,
  method: httpMethod.get,
  url: `/API/transcode/v1/transcode/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/`,
  params: { objectType, objectId },
  headers,
});

/**
 * `GET /v1/transcode/{object_type}/{object_id}/versions/{version_id}/`
 *
 * Returns list of transcode queue records by version_id
 *
 * Required roles:
 *  - can_read_transcode_jobs
 *
 * Responses
 * - 200 - Returns list of transcode queue records
 * - 400 - Bad request - malformed parameters
 *
 * Response {@link TranscodeTranscodeESQueueRecordsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/get_v1_transcode__object_type___object_id__versions__version_id__}
 */
export const httpGetTranscodeByObjectTypeByObjectIdVersionsByVersionId = (
  objectType: string,
  objectId: string,
  versionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpGetTranscodeByObjectTypeByObjectIdVersionsByVersionId,
  method: httpMethod.get,
  url: `/API/transcode/v1/transcode/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/versions/${encodeURIComponent(versionId)}/`,
  params: { objectType, objectId, versionId },
  headers,
});

/**
 * `DELETE /v1/transcode/{transcode_job_id}/`
 *
 * Cancel a particular transcode job by id
 *
 * Required roles:
 *  - can_delete_transcode_jobs
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Transcode does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/delete_v1_transcode__transcode_job_id__}
 * @deprecated
 */
export const httpDeleteTranscodeByTranscodeJobId = (
  transcodeJobId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpDeleteTranscodeByTranscodeJobId,
  method: httpMethod.delete,
  url: `/API/transcode/v1/transcode/${encodeURIComponent(transcodeJobId)}/`,
  params: { transcodeJobId },
  headers,
});

/**
 * `GET /v1/transcode/{transcode_job_id}/`
 *
 * Get transcode job
 *
 * Required roles:
 *  - can_read_transcode_jobs
 *
 * Responses
 * - 200 - Returns the status of a particular transcode job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Transcode job does not exist
 *
 * Response {@link TranscodeJobSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/get_v1_transcode__transcode_job_id__}
 */
export const httpGetTranscodeByTranscodeJobId = (
  transcodeJobId: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpGetTranscodeByTranscodeJobId,
  method: httpMethod.get,
  url: `/API/transcode/v1/transcode/${encodeURIComponent(transcodeJobId)}/`,
  params: { transcodeJobId },
  headers,
});

/**
 * `POST /v1/transcode/{transcode_job_id}/position/{position}/`
 *
 * Move transcode job to top or bottom of the queue
 *
 * Required roles:
 *  - can_write_transcode_jobs
 *
 * Responses
 * - 200 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Transcode job already started
 * - 404 - Transcode does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_transcode__transcode_job_id__position__position__}
 * @deprecated
 */
export const httpPostTranscodeByTranscodeJobIdPositionByPosition = (
  transcodeJobId: string,
  position: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostTranscodeByTranscodeJobIdPositionByPosition,
  method: httpMethod.post,
  url: `/API/transcode/v1/transcode/${encodeURIComponent(transcodeJobId)}/position/${encodeURIComponent(position)}/`,
  params: { transcodeJobId, position },
  headers,
});

/**
 * `PUT /v1/transcode/{transcode_job_id}/priority/{priority}/`
 *
 * Change transcode job priority
 *
 * Required roles:
 *  - can_write_transcode_jobs
 *
 * Responses
 * - 200 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Transcode job already started
 * - 404 - Transcode does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/put_v1_transcode__transcode_job_id__priority__priority__}
 * @deprecated
 */
export const httpPutTranscodeByTranscodeJobIdPriorityByPriority = (
  transcodeJobId: string,
  priority: string,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPutTranscodeByTranscodeJobIdPriorityByPriority,
  method: httpMethod.put,
  url: `/API/transcode/v1/transcode/${encodeURIComponent(transcodeJobId)}/priority/${encodeURIComponent(priority)}/`,
  params: { transcodeJobId, priority },
  headers,
});

/**
 * `POST /v1/transcribe/assets/{asset_id}/profiles/default/`
 *
 * Start a job that sends an asset to default transcription service
 *
 * Required roles:
 *  - can_transcribe_content
 *
 * Responses
 * - 201 - Returns a definition of the started job
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_transcribe_assets__asset_id__profiles_default_}
 */
export const httpPostTranscribeAssetsByAssetIdProfilesDefault = (
  assetId: string,
  body: TranscodeTranscribeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostTranscribeAssetsByAssetIdProfilesDefault,
  method: httpMethod.post,
  url: `/API/transcode/v1/transcribe/assets/${encodeURIComponent(assetId)}/profiles/default/`,
  params: { assetId },
  body,
  headers,
});

/**
 * `POST /v1/transcribe/bulk/`
 *
 * Start a job that sends multiple objects to transcription service
 *
 * Required roles:
 *  - can_transcribe_content
 *
 * Responses
 * - 201 - Returns a definition of the started job
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/transcode/spec/#/default/post_v1_transcribe_bulk_}
 */
export const httpPostTranscribeBulk = (
  body: TranscodeBulkTranscribeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: TranscodeHttpPostTranscribeBulk,
  method: httpMethod.post,
  url: '/API/transcode/v1/transcribe/bulk/',

  body,
  headers,
});
